import { createContext } from 'preact';

import { ButtonSetPosition } from '../../utils/UNSAFE_buttonUtils';

export type ButtonSetPositionContextProps = {
  /**
   * The position modifies the borders for usage inside a button group.
   */
  position?: ButtonSetPosition;
};

/**
 * Context which the parent component can use to provide various ToggleButton related
 * information
 */
export const ButtonSetPositionContext = createContext<ButtonSetPositionContextProps>({
  position: 'single'
});
